import React from "react";
import ReactDOM from "react-dom/client";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import Routers from "./components/routers/Routers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Routers />);

// serviceWorkerRegistration.register({
// 	onSuccess(registration) {
// 		console.debug("serviceWorkerRegistration success");
// 	},
// 	async onUpdate(registration) {
// 		console.debug("serviceWorkerRegistration updated");
// 		// Always clear cache on update
// 		await registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
// 		if ("caches" in window) {
// 			const names = await caches.keys();
// 			for (const name of names) {
// 				await caches.delete(name);
// 			}
// 		}
// 		window.location.reload();
// 	},
// });

reportWebVitals();
